import { CssBaseline } from '@pickupp/ui/core'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import Helmet from 'react-helmet'

import { MODE } from '~/config'
import { LayoutContext } from '~/src/contexts'

import BingAds from '../Analytics/BingAds'
import FBPixels from '../Analytics/FBPixels'
import GTM from '../Analytics/GTM'
import Linkedin from '../Analytics/Linkedin'
import BackToTopButton from '../BackToTopButton'
import ErrorBoundary from '../ErrorBoundary'
import Footer from '../Footer'
import FooterV3 from '../FooterV3'
import Header from '../Header'
import HeaderV2 from '../HeaderV2'
import Notification from '../Notification'
import RegionDialog from '../RegionDialog'

const Page = ({ children, layoutContext, settingContext }) => {
  const {
    header,
    headerV2,
    footer,
    footerV3,
    navigationHeader,
    footerType,
    notification,
  } = {
    ...useContext(LayoutContext),
    ...layoutContext,
    ...settingContext,
  }

  const navHeader = navigationHeader || 'default'

  const selectedHeader = headerV2.data.find((el) => el.attributes.key === navHeader)
  const footerV3Type = footerType || 'default'
  const selectedFooterV3 = footerV3.data.find((el) => el.attributes.key === footerV3Type)

  return (
    <>
      {(MODE === 'production') && (
        <>
          <FBPixels />
          <Linkedin />
          <BingAds />
        </>
      )}
      <GTM />
      <Helmet>
        {/* https://cdnjs.cloudflare.com/ajax/libs/loadCSS/3.1.0/loadCSS.min.js */}
        <script>
          {'!function(c){"use strict";function e(e,t,n,o){var r,i=c.document,d=i.createElement("link");if(t)r=t;else{var a=(i.body||i.getElementsByTagName("head")[0]).childNodes;r=a[a.length-1]}var f=i.styleSheets;if(o)for(var l in o)o.hasOwnProperty(l)&&d.setAttribute(l,o[l]);d.rel="stylesheet",d.href=e,d.media="only x",function e(t){if(i.body)return t();setTimeout(function(){e(t)})}(function(){r.parentNode.insertBefore(d,t?r:r.nextSibling)});var s=function(e){for(var t=d.href,n=f.length;n--;)if(f[n].href===t)return e();setTimeout(function(){s(e)})};function u(){d.addEventListener&&d.removeEventListener("load",u),d.media=n||"all"}return d.addEventListener&&d.addEventListener("load",u),(d.onloadcssdefined=s)(u),d}"undefined"!=typeof exports?exports.loadCSS=e:c.loadCSS=e}("undefined"!=typeof global?global:this);'}
        </script>
        <script id="loadcss">
          {`
            loadCSS('https://fonts.googleapis.com/icon?family=Material+Icons', document.getElementById('loadcss') )
            loadCSS('https://use.fontawesome.com/releases/v5.11.2/css/all.css', document.getElementById('loadcss') )
          `}
        </script>
      </Helmet>
      <CssBaseline />
      {!selectedHeader ? (
        <Header {...header} />
      ) : (
        <HeaderV2
          {...selectedHeader.attributes}
          key={`header-${selectedHeader.attributes.key}`}
        />
      )}
      <main style={{ overflow: 'hidden', position: 'relative' }}>
        <ErrorBoundary>
          {notification && <Notification notification={notification[0]} />}
          {children}
        </ErrorBoundary>
      </main>
      {!selectedFooterV3 ? (
        <Footer {...footer} />
      ) : (
        <FooterV3
          {...selectedFooterV3.attributes}
          key={`footer-${selectedFooterV3.attributes.key}`}
        />
      )}
      <BackToTopButton />
      <RegionDialog />
    </>
  )
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Page
